import { authService } from '@ygoargentina/sdk/api/auth-service';

/**
 * ¿Se perdió de verdad la sesión? Se pregunta antes de desloguear por un error.
 *
 * `isAuthError` reconoce la sesión vencida por el mensaje, y el API usa
 * `unauthorized` también para negar permisos (`!isAdmin`, «no sos dueño»):
 * un error de permisos sacaba al usuario. Peor, borraba el CSRF del
 * localStorage, y las otras pestañas de folder lo leían como un logout y
 * quedaban con el usuario del store en null y la pantalla montada (sidebar de
 * jugador sin rol, sin avatar, «Email no validado») hasta recargar.
 *
 * Sólo `none` —el API confirmó que no hay sesión— cuenta como perdida. Si no se
 * pudo saber (red, 5xx), se deja la sesión: el error ya lo muestra la pantalla.
 *
 * Los avisos que llegan juntos (varias queries que fallan a la vez) comparten
 * un solo `/auth/me`.
 */
let inFlight: Promise<boolean> | null = null;

export const confirmSessionLost = (origin: string): Promise<boolean> => {
  if (inFlight) return inFlight;

  inFlight = authService
    .verifySession()
    .then((session) => {
      if (session.status === 'none') {
        console.info('[auth] sesión perdida confirmada', {
          origin,
          reason: session.reason,
        });
        return true;
      }

      console.warn(
        '[auth] error de auth con la sesión vigente: no se desloguea',
        {
          origin,
          status: session.status,
          reason: session.status === 'unknown' ? session.reason : undefined,
        }
      );
      return false;
    })
    .finally(() => {
      inFlight = null;
    });

  return inFlight;
};
